import DefaultLandingPage from "./DefaultLandingPage";

export default DefaultLandingPage;